export enum enumPreferredLanguage {
  Afrikaans = 1,
  English,
  Other,
  Pedi,
  'Shangaan-Stonga' ,
  'South Sotho',
  Swazi,
  Tswana,
  Venda,
  Xhoza,
  Zulu,
  Ndebele,
  Sepedi,
  Swati,
  Tsonga,
  'Not Selected'
}

export namespace enumPreferredLanguage {
  export function values() {
    return Object.keys(enumPreferredLanguage).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
